/**
 * Created by user on 2018/2/17/017.
 */

import cjkConv from './lib/index';
export * from './version';

export { cjkConv }

export * from './lib/index';
export default cjkConv;
